import styled from 'styled-components'
import { defaultTheme } from '../../theming/data/defaultTheme'
import fonts from '../../tokens/fonts'
import { composeTheme } from '../../utils/compose-theme'

export const Tooltip = styled.div`
  display: inline-block;
  position: relative;
`

export const TooltipText = styled.div.attrs((props) => composeTheme(props))`
  background-color: ${(props) => props.theme.tooltip.backgroundColor};
  border-radius: ${(props) => props.theme.tooltip.borderRadius};
  bottom: calc(100% + ${(props) => props.theme.tooltip.margin});
  box-shadow: ${(props) => props.theme.tooltip.boxShadow};
  color: ${(props) => props.theme.tooltip.color};
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.tooltip.fontSize};
  font-style: normal;
  font-weight: ${(props) => props.theme.tooltip.fontWeight};
  left: 50%;
  line-height: ${(props) => props.theme.tooltip.lineHeight};
  padding: ${(props) => props.theme.tooltip.padding};
  position: absolute;
  text-align: ${(props) => props.theme.tooltip.textAlign};
  transform: translateX(-50%);
  width: ${(props) => props.theme.tooltip.width};
  z-index: 100;

  .arrayItem {
    margin-bottom: ${(props) => props.theme.tooltip.arrayItemMarginButtom};
  }

  &::before {
    content: ' ';
    left: 50%;
    border: solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-top-color: ${(props) => props.theme.tooltip.backgroundColor};
    border-width: ${(props) => props.theme.tooltip.arrowSize};
    margin-left: calc(${(props) => props.theme.tooltip.arrowSize} * -1);
    top: 100%;
    filter: drop-shadow(${(props) => props.theme.tooltip.arrowBoxShadow});
  }

  &.right {
    bottom: auto;
    left: calc(100% + ${(props) => props.theme.tooltip.margin});
    top: 50%;
    transform: translateX(0) translateY(-50%);

    &::before {
      border-right-color: ${(props) => props.theme.tooltip.backgroundColor};
      border-top-color: transparent;
      left: calc(${(props) => props.theme.tooltip.arrowSize} * -1);
      top: 50%;
      transform: translateX(0) translateY(-50%);
    }
  }

  &.left {
    bottom: auto;
    left: auto;
    right: calc(100% + ${(props) => props.theme.tooltip.margin});
    top: 50%;
    transform: translateX(0) translateY(-50%);

    &::before {
      border-left-color: ${(props) => props.theme.tooltip.backgroundColor};
      border-top-color: transparent;
      left: auto;
      right: calc(${(props) => props.theme.tooltip.arrowSize} * -2);
      top: 50%;
      transform: translateX(0) translateY(-50%);
    }
  }

  &.bottom {
    bottom: auto;
    top: calc(100% + ${(props) => props.theme.tooltip.margin});

    &::before {
      border-bottom-color: ${(props) => props.theme.tooltip.backgroundColor};
      border-top-color: transparent;
      bottom: 100%;
      top: auto;
    }
  }
`
TooltipText.defaultProps = defaultTheme
